module.exports = __webpack_public_path__ + "fonts/manrope-thin.bdfba78b.woff";